/**
 * @since 2025-02-19
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import App from "./App";

export default App;
